import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { clinicInfo } from '../data/mock';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo and Name */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_heart-paws-vet/artifacts/yu8d4sa5_ChatGPT%20Image%202%20de%20nov.%20de%202025%2C%2018_55_34.png" 
              alt="Logo" 
              className="w-10 h-10 object-contain"
              style={{ filter: 'brightness(0) saturate(100%) invert(31%) sepia(89%) saturate(2715%) hue-rotate(258deg) brightness(91%) contrast(92%)' }}
            />
            <div>
              <h1 className="text-xl font-bold text-purple-900">{clinicInfo.name}</h1>
              <p className="text-xs text-purple-600">Cuidando com amor</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Início
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Sobre
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Serviços
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Depoimentos
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Contato
            </button>
          </nav>

          {/* CTA Button */}
          {/* <div className="hidden md:block">
            <Button 
              onClick={() => scrollToSection('appointment')}
              className="bg-purple-600 hover:bg-purple-700 text-white"
            >
              <Phone className="w-4 h-4 mr-2" />
              Agendar Consulta
            </Button>
          </div> */}

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4">
            <button onClick={() => scrollToSection('home')} className="text-left text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Início
            </button>
            <button onClick={() => scrollToSection('about')} className="text-left text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Sobre
            </button>
            <button onClick={() => scrollToSection('services')} className="text-left text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Serviços
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-left text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Depoimentos
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-purple-600 transition-colors font-medium">
              Contato
            </button>
            {/* <Button 
              onClick={() => scrollToSection('appointment')}
              className="bg-purple-600 hover:bg-purple-700 text-white w-full"
            >
              <Phone className="w-4 h-4 mr-2" />
              Agendar Consulta
            </Button> */}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;